import { types } from 'mobx-state-tree';
export const SettingsModel = {
    platform: types.optional(types.string, ''),
    isPrivacyApproved: types.optional(types.boolean, false),
    isAutoOpen: types.optional(types.boolean, true),
    isExtendedMenuOpen: types.optional(types.boolean, false),
    pluginTypeVariant: types.optional(types.string, 'Normal'),
    lusha: types.optional(types.boolean, true),
    externalPluginVersion: types.optional(types.string, ''),
    pluginSide: types.optional(types.string, ''),
    initialUrl: types.optional(types.string, ''),
    isPluginOpen: types.optional(types.maybeNull(types.boolean), null),
    isScoutEnabled: types.maybeNull(types.boolean),
    isAllWebsitesPermissionsGranted: types.maybeNull(types.boolean),
    shouldShowGmailOnBoarding: types.optional(types.boolean, true),
    isMoreMenuV2AnnouncementShown: types.optional(types.boolean, false),
    isAlignExtensionTestSupported: types.optional(types.boolean, false),
    shouldShowSfdePromoBanner: types.optional(types.boolean, false),
    shouldShowCrmIntegrationsUpdateAnnouncement: types.optional(types.boolean, false),
    isFeatureBranch: types.optional(types.boolean, false),
};
